let lastAddedTradeIn = null;
yesButton = $('#numi-btn-yes');
noButton = $('#numi-btn-no');
productDropDown = $('#numi-product-select');
sizeDropDown = $('#numi-size-select');
radioSelect = $('.numi-radio-element');
addToCartButton = $('#numi-btn-add');
editButton = $('#numi-btn-edit');
tradeInForm = $("#numi-form-holder");
confirmationMessage = $('#numi-confirmation');

// Show form when user clicks on the button
yesButton.click(function () {
    show('#numi-form-holder', 0);
    $(this).addClass('btn-active');
    noButton.removeClass('btn-active');
});

// Hide form when user clicks on the button
noButton.click(function () {
    hide('#numi-form-holder');
    hide('#numi-confirmation');
    $(this).addClass('btn-active');
    yesButton.removeClass('btn-active');
    removeTradeInFromCart(lastAddedTradeIn);
});

// Question 1 register change and show next question
productDropDown.change(function () {
    $(this).find('option:selected').each(function () {
        // Get product handle to show the correct sizes in the next dropdown
        let optionValue = $(this).attr('value');
        optionValue = optionValue.replace(/\s+/g, '-').toLowerCase();
        optionValue = optionValue.replace('---', '-');
        populateSizeDropdown(optionValue);

        // Show next question if the user selected a product
        if (optionValue) {
            show('#numi-q2', 0);
        } else {
            hide('#numi-q2');
        }
    });
});

// Question 2 register change and show next question
sizeDropDown.change(function () {
    $(this).find('option:selected').each(function () {
        // Show next question if size is selected
        let optionValue = $(this).attr('value');
        if (optionValue) {
            show('#numi-q3', 0);
        } else {
            hide('#numi-q3');
        }
    });
});


// Question 3 register change and enable button
radioSelect.change(function () {
    toggleAddToCartButton(true);
});

testAddButton = $('#numi-add-button');
testAddInput = $('#numi-add-input');
testAddButton.click(function () {
    let productHandle = productDropDown.val();
    productHandle = productHandle.replace(/\s+/g, '-').toLowerCase();
    productHandle = productHandle.replace('---', '-');
    let condition = null;
    if ($('#condition1').is(':checked')) {
        condition = 'Liebevoll benutzt';
    }
    if ($('#condition2').is(':checked')) {
        condition = 'Braucht Liebe';
    }
    if ($('#condition3').is(':checked')) {
        condition = 'Muss recyclet werden';
    }
    let productSize = sizeDropDown.val();
    let productCondition = condition;

    populateAddButton(productHandle, productSize, productCondition);
});

function populateAddButton(handle, size, condition) {
    // Get the right product
    fetch(window.Shopify.routes.root + "products/" + handle + ".js")
        .then((response) => response.json())
        .then((data) => {
            let variantId = null;
            for (variant of data.variants) {
                if (variant.option1 === size && variant.option2 === condition) {
                    variantId = variant.id;
                    // Display the right payout value in the confirmation message
                    editPayoutDisplay(variant.option3);
                }
            }
            //set the variant id as a data attribute on the add to cart button
            testAddInput.attr('data-variant-id', variantId);
            //do not redirect to the cart page
            testAddInput.attr('data-cart-redirection', false);
        })
}

// Add Trade-In Button
addToCartButton.click(function () {

    // Get product information and call addTradeInToCart
    let productHandle = productDropDown.val();
    productHandle = productHandle.replace(/\s+/g, '-').toLowerCase();
    productHandle = productHandle.replace('---', '-');
    let condition = null;
    if ($('#condition1').is(':checked')) {
        condition = 'Liebevoll benutzt';
    }
    if ($('#condition2').is(':checked')) {
        condition = 'Braucht Liebe';
    }
    if ($('#condition3').is(':checked')) {
        condition = 'Muss recyclet werden';
    }
    let productSize = sizeDropDown.val();
    let productCondition = condition;

    addTradeInToCart(productHandle, productSize, productCondition);
  
    // Hide form and show confirmation
    hide('#numi-form-holder');
    show('#numi-confirmation', 0);

    // Show confirmation message and show a confetti animation based on screen size
    //confirmationMessage[0].scrollIntoView({behavior: 'smooth', block: 'center'});
    setTimeout(
        function () {
            if ($(window).width() < 750) {
                confetti({
                    spread: 70,
                    origin: {
                        x: 0.5,
                        y: 0.8
                    }
                });
            }
            if ($(window).width() > 749 && $(window).width() < 1920) {
                confetti({
                    spread: 70,
                    origin: {
                        x: 0.75,
                        y: 0.75
                    }
                });
            }
            if ($(window).width() > 1919 && $(window).width() < 3000) {
                confetti({
                    spread: 70,
                    origin: {
                        x: 0.65,
                        y: 0.55
                    }
                });
            }
            if ($(window).width() > 2999) {
                confetti({
                    spread: 70,
                    origin: {
                        x: 0.6,
                        y: 0.55
                    }
                });
            }
        }, 300);
});

// Edit button
editButton.click(function () {
    // Remove Trade-In from cart so user can adjust the form
    removeTradeInFromCart(lastAddedTradeIn);
    // Show form and hide confirmation
    show('#numi-form-holder', 0);
    hide('#numi-confirmation');
    //tradeInForm[0].scrollIntoView({behavior: 'smooth', block: 'center'});
});

// Show next element in the form
function show(element, delay) {
    setTimeout(
        function () {
            $(element).addClass('auto-height');
        }, delay);
}

// Hide element
function hide(element) {
    $(element).removeClass('auto-height');
}

// Enable/disable the add to cart button
function toggleAddToCartButton(enable) {
    if (enable) {
        addToCartButton.removeAttr('disabled');
    } else {
        addToCartButton.prop("disabled", true);
    }
}

function populateSizeDropdown(handle) {
    // Hide all other questions
    toggleAddToCartButton(false);
    hide('#numi-q3');
    hide('#numi-q2');
    show('#numi-q2', 0);
    // Clear the radio buttons
    clearConditionRadios();
    // Clear size dropdown and show the right sizes
    sizeDropDown.empty();
    sizeDropDown.append(
        $('<option></option>').val('').html('Größe wählen').attr('disabled', 'disabled').attr('selected', 'selected')
    );
    fetch(window.Shopify.routes.root + "products/" + handle + ".js")
        .then((response) => response.json())
        .then((data) => {
            let uniqueVariant = "";
            for (variant of data.variants) {
                if (uniqueVariant !== variant.option1) {
                    sizeDropDown.append(
                        $('<option></option>').val(variant.option1).html(variant.option1)
                    );
                    uniqueVariant = variant.option1;
                }
            }
            return data;
        });
}

function clearConditionRadios() {
    $("#condition1").prop('checked', false);
    $("#condition2").prop('checked', false);
    $("#condition3").prop('checked', false);
}

function addTradeInToCart(handle, size, condition) {
    // Get the right product
    fetch(window.Shopify.routes.root + "products/" + handle + ".js")
        .then((response) => response.json())
        .then((data) => {
            let variantId = null;
            for (variant of data.variants) {
                if (variant.option1 === size && variant.option2 === condition) {
                    variantId = variant.id;
                    // Display the right payout value in the confirmation message
                    editPayoutDisplay(variant.option3);
                }
            }
            let lineItem = {
                id: variantId,
                quantity: 1,
            };

            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: lineItem,
                dataType: 'json',
                success: function (data) {
                    //console.log("✅ Trade-In added");
                    //console.log(data);
                    lastAddedTradeIn = data.id;
                }
            });
        });
}

function removeTradeInFromCart(id) {
    if (lastAddedTradeIn) {
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                quantity: 0,
                id: id,
            },
            dataType: 'json',
            success: function (data) {
                //console.log("🫡 Trade-In removed");
                console.log(data);
            }
        });
    } else {
        console.log("No Trade-In to remove");
    }
}

function editPayoutDisplay(value) {
    $('#numi-payout').html(value);
    $('#numi-payout-next-steps').html(value);
}

function checkForTradeIn(){
    //console.log('🔍 Trade-In Check');
    var tradeIn = 0;
    var cartContents = fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((data) => {
            for (item in data.items) {
                item = data.items[item];
                if (item.product_type == "Trade-In") {
                    tradeIn++;
                }
            }
            if (tradeIn > 0){
                console.log('✅ ' + tradeIn + ' Trade-Ins in cart');
                $(".numi-cart-holder").show();
            }
            else {
                //console.log('❌ No Trade-Ins in cart');
                $(".numi-cart-holder").hide();
            }
        });
}

// Check for Trade-In when Shopify add-to-cart button is clicked
$('button[name="add"]').click(function(){
    setTimeout(checkForTradeIn,500);
});

